import domain from './domain';

// Reset plans
export const resetPlans = domain.createEvent('resetPlans');